import StringUtils from "utilities/string-utils";

export interface ScopedDragAndDropData {
    scope: string;
}

export const enforceScopedDragAndDropData = (
    data: any
): ScopedDragAndDropData | undefined => {
    const scope = data?.scope;

    if (StringUtils.isEmpty(scope)) {
        return undefined;
    }

    return data as ScopedDragAndDropData;
};
